var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57_8451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 12,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5303 2.99894C11.2375 2.72299 10.7626 2.72299 10.4697 2.99894L6.00022 7.20994L1.53073 2.99894C1.23785 2.72299 0.762993 2.72299 0.470111 2.99894C0.177229 3.27488 0.177229 3.72227 0.470111 3.99821L6.00022 9.2085L11.5303 3.99821C11.8232 3.72227 11.8232 3.27488 11.5303 2.99894Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57_8451)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.499023,
    width: 11.9995,
    height: 10.9997,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.5cac156d9cf5ece44d81baaacfc02bb3.svg";
export { ForwardRef as ReactComponent };